import { render, staticRenderFns } from "./ButtonNav.vue?vue&type=template&id=5f720583&scoped=true&"
import script from "./ButtonNav.vue?vue&type=script&lang=js&"
export * from "./ButtonNav.vue?vue&type=script&lang=js&"
import style0 from "./ButtonNav.vue?vue&type=style&index=0&id=5f720583&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f720583",
  null
  
)

export default component.exports